import { publicReportsList } from "@/mocks/publico";

export default function PublicReportsSection() {
  return (
    <section id="relatorios" className="py-14 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">Relatórios Públicos</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Acesse relatórios publicados de arborização urbana, áreas verdes, indicadores ambientais, carbono e transparência.
          </p>
        </div>

        <div className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-background-200 bg-background-100/50">
                  <th className="text-left px-5 py-3 text-xs font-semibold text-foreground-500 uppercase whitespace-nowrap">Relatório</th>
                  <th className="text-left px-5 py-3 text-xs font-semibold text-foreground-500 uppercase whitespace-nowrap">Tipo</th>
                  <th className="text-left px-5 py-3 text-xs font-semibold text-foreground-500 uppercase whitespace-nowrap">Período</th>
                  <th className="text-left px-5 py-3 text-xs font-semibold text-foreground-500 uppercase whitespace-nowrap">Publicação</th>
                  <th className="text-left px-5 py-3 text-xs font-semibold text-foreground-500 uppercase whitespace-nowrap">Formato</th>
                  <th className="text-right px-5 py-3 text-xs font-semibold text-foreground-500 uppercase whitespace-nowrap">Ações</th>
                </tr>
              </thead>
              <tbody>
                {publicReportsList.map((report) => (
                  <tr key={report.id} className="border-b border-background-200/70 hover:bg-background-50 transition-colors">
                    <td className="px-5 py-3">
                      <span className="text-sm text-foreground-900 font-medium">{report.titulo}</span>
                      <p className="text-xs text-foreground-400">{report.municipio}</p>
                    </td>
                    <td className="px-5 py-3">
                      <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-secondary-50 text-secondary-700 whitespace-nowrap">
                        {report.tipo}
                      </span>
                    </td>
                    <td className="px-5 py-3 text-foreground-600 text-xs whitespace-nowrap">{report.periodo}</td>
                    <td className="px-5 py-3 text-foreground-600 text-xs whitespace-nowrap">{report.publicacao}</td>
                    <td className="px-5 py-3">
                      <span className="text-xs font-mono text-foreground-500 bg-background-100 px-2 py-0.5 rounded">{report.formato}</span>
                    </td>
                    <td className="px-5 py-3 text-right">
                      <div className="flex items-center justify-end gap-2">
                        <button className="p-1.5 rounded-md hover:bg-background-100 text-foreground-500 transition-colors cursor-pointer" title="Visualizar">
                          <i className="ri-eye-line w-4 h-4 flex items-center justify-center" />
                        </button>
                        <button className="p-1.5 rounded-md hover:bg-background-100 text-primary-600 transition-colors cursor-pointer" title="Baixar PDF">
                          <i className="ri-download-line w-4 h-4 flex items-center justify-center" />
                        </button>
                        <button className="p-1.5 rounded-md hover:bg-background-100 text-foreground-500 transition-colors cursor-pointer" title="Compartilhar">
                          <i className="ri-share-line w-4 h-4 flex items-center justify-center" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}